import { useContext } from "react";
import Valve from "../components/Valve";
import Transmitter4 from "../components/Transmitter4";
import Transmitter from "../components/Transmitter";
import "./ProductionHeader2.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";

import { trackPageVisit } from "../competency/PageTracker";


 


 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }



function ProductionHeader2() {

        useEffect(() => {
  
    trackPageVisit("ProductionHeader2");
  
  }, []);

  const {  wellSignals, valves, toggleValve, updateValveData } = useContext(WellContext);

     


              /* 🔥 TRANSMITTER OUTPUTS */


const isXV10303Open = !valves.XV_10303;
const isXV10701Open = !valves.XV_10701;
const isXV10702Open = !valves.XV_10702;


const FIC_10701 = isXV10303Open && isXV10701Open
  ? (wellSignals?.NK3?.fic2 || 0)
  : 0;

const PT_10701 = isXV10701Open && isXV10303Open
  ? (wellSignals?.NK3?.pt || 0)
  : 0;

const TT_10701 = isXV10701Open && isXV10303Open
  ? (wellSignals?.NK3?.tt || 0)
  : 0;



const isXV10504Open = !valves.XV_10504;

const MPFT_10701 =
  isXV10701Open && isXV10303Open && isXV10702Open
    ? (
        (wellSignals?.NK3?.oil || 0) 
      )
    : 0;


  const MPFT_10702 =
  isXV10701Open && isXV10303Open && isXV10702Open
    ? (
        (wellSignals?.NK3?.gas || 0) 
      )
    : 0;


  const MPFT_10703 =
  isXV10701Open && isXV10303Open && isXV10702Open
    ? (
        (wellSignals?.NK3?.water || 0) 
      )
    : 0;






const [fic10703, setFic10703] = useState(0);

const isXV10703Open = !valves.XV_10703;

useEffect(() => {
  const target = isXV10703Open ? 45.432 : 0;

  const interval = setInterval(() => {
    setFic10703(prev => {
      const diff = target - prev;

      // smooth approach
      let next = prev + diff * 0.1;

      // snap when very close
      if (Math.abs(diff) < 0.01) {
        next = target;
      }

      return next;
    });
  }, 200);

  return () => clearInterval(interval);
}, [isXV10703Open]);


     const { setTransmitters } = useContext(WellContext);
      useEffect(() => {
        setTransmitters(prev => ({
          ...prev,
          MPFT_10701: MPFT_10701
        }));
      }, [MPFT_10701]);

      useEffect(() => {
        setTransmitters(prev => ({
          ...prev,
          MPFT_10702: MPFT_10702
        }));
      }, [MPFT_10702]);
  
      useEffect(() => {
        setTransmitters(prev => ({
          ...prev,
          MPFT_10703: MPFT_10703
        }));
      }, [MPFT_10703]);
  
      useEffect(() => {
        setTransmitters(prev => ({
          ...prev,
          PT_10701: PT_10701
        }));
      }, [PT_10701]);

      useEffect(() => {
        setTransmitters(prev => ({
          ...prev,
          TT_10701: TT_10701
        }));
      }, [TT_10701]);
  
      
    




  return (
    <div className="ProductionHeader2-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "2px",
        left: "246px",
        color: "white",
        background: "rgb(28, 3, 250)",
        padding: "2.2px 250px"
      }}>
        PRODUCTION HEADER 2
      </h2>


    {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-10701 */}
      <Valve
        className="XV-10701"
        tag="XV_10701"
        x={135}
        y={146}
        isClosed={valves.XV_10701}
        toggle={toggleValve}
      />

              {/* XV-10702 */}
      <Valve
        className="XV-10702"
        tag="XV_10702"
        x={1002}
        y={172}
        isClosed={valves.XV_10702}
        toggle={toggleValve}
      />

        {/* XV-10703 */}
      <Valve
        className="XV-10703"
        tag="XV_10703"
        x={789}
        y={428}
        isClosed={valves.XV_10703}
        toggle={toggleValve}
      />




    <Transmitter
      value={FIC_10701}
      x={592}
      y={312}
      unit="BOE/M"
      max={170}
      HH={155}
      H={110}
      L={1}
      LL={0.1}
      c="lime"
      description="FLOWRATE OF OIL AND GAS FLUID FROM NK-3 WELLHEAD TO SLUDGE CATCHER"
      tag="FIC_10701"
     />

     <Transmitter
      value={PT_10701}
      x={739}
      y={312}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF OIL AND GAS FLUID FROM NK-3 WELLHEAD TO SLUDGE CATCHER"
      tag="PT-10701"
     />

     <Transmitter
      value={TT_10701}
      x={858}
      y={312}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="TEMPERATURE OF OIL AND GAS FLUID FROM NK-3 WELLHEAD TO SLUDGE CATCHER"
      tag="TT-10701"
     />

     <Transmitter
      value={MPFT_10701}
      x={1085}
      y={102}
      unit="BPM"
      max={170}
      HH={155}
      H={110}
      L={1}
      LL={0.1}
      c="lime"
      description="FLOWRATE OF CRUDE FROM NK-3 WELLHEAD TO SLUDGE CATCHER"
      tag="MPFT-10701"
     />

     <Transmitter
      value={MPFT_10702}
      x={1085}
      y={116}
      unit="SCF/S"
      max={170}
      HH={155}
      H={110}
      L={1}
      LL={0.1}
      c="lime"
      description="FLOWRATE OF GAS FROM NK-3 WELLHEAD TO SLUDGE CATCHER"
      tag="MPFT-10702"
     />

     <Transmitter
      value={MPFT_10703}
      x={1085}
      y={130}
      unit="LPM"
      max={20}
      HH={15}
      H={10}
      L={1}
      LL={0.1}
      c="lime"
      description="FLOWRATE OF SEDIMENT AND WATER FROM NK-3 WELLHEAD TO SLUDGE CATCHER"
      tag="MPFT-10703"
     />

     <Transmitter
      value={fic10703}
      x={928}
      y={425}
      unit="BOE/M"
      max={170}
      HH={155}
      H={110}
      L={1}
      LL={0.1}
      c="lime"
      description="FLOWRATE OF OIL AND GAS FLUID TO CLOSE DRAIN FROM PRODUCTION HEADER-2"
      tag="FIC-10703"
     />

    





      

    </div>
  );
}

export default ProductionHeader2;
